import React from 'react';

export default function PanelDebug({ barrioCounts, debugInfo }) {
  return (
    <div className="absolute top-2 z-20 max-w-xs bg-white bg-opacity-95 rounded-lg shadow-lg p-2 text-[10px] font-mono text-gray-700 pointer-events-none" style={{ left: '230px' }}>
      <div className="font-semibold text-gray-500 mb-1">DEBUG BARRIOS</div>
      <div>Targets: {barrioCounts.targets} | Total: {barrioCounts.total}</div>
      <div>RENABAP: {barrioCounts.renabap ?? '?'} | RPPVAP: {barrioCounts.rppvap ?? '?'} | Otros: {barrioCounts.otros ?? '?'}</div>
      {debugInfo && (
        <pre className="mt-1 whitespace-pre-wrap text-[9px] leading-tight bg-gray-100 p-1 rounded">{debugInfo}</pre>
      )}
    </div>
  );
}
